import { DISCOVERY_STEPS, DOCUMENT_STEPS, DOCUMENT_STEPS_CLASSIFIED } from './flowSteps';
import { HowItWorksFlow } from './HowItWorksFlow';

interface ProcessingShowcaseProps {
  /** Which backend pipeline to mirror. */
  variant: 'document' | 'discovery';
  /** Active step index, derived from the live stage (see stageToStep). */
  step: number;
  /** Live label (stage / progress message) shown on the flow card. */
  caption?: string | undefined;
  /**
   * When true (document variant only), render the 7-step rail that includes the «Clasificando» beat,
   * for an auto-classified job. Ignored for the discovery variant.
   */
  classified?: boolean;
}

/**
 * Shared in-flight panel: the state-driven "Cómo funciona" animation, with its
 * steps mirroring the chosen backend pipeline 1:1 so the rail matches what Azure
 * Functions reports. Used by the document reviewer and the discovery wizard.
 */
export function ProcessingShowcase({ variant, step, caption, classified = false }: ProcessingShowcaseProps): JSX.Element {
  const steps =
    variant === 'discovery'
      ? DISCOVERY_STEPS
      : classified
        ? DOCUMENT_STEPS_CLASSIFIED
        : DOCUMENT_STEPS;
  const clamped = Math.max(0, Math.min(steps.length - 1, step));
  const fallbackCaption = steps[clamped]?.rail;
  return (
    <div className="card overflow-hidden p-6">
      <HowItWorksFlow steps={steps} activeIndex={step} caption={caption ?? fallbackCaption} />
    </div>
  );
}
